import SpriteComponent from '../../../Component/Render/Sprite';
import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import { AwaitIterators } from '../AnimationHelper';
import TransformComponent from '../../../Component/Transform';

export class SpritePopIn extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform = gameObject.getComponent(TransformComponent);
        const spriteComponent = gameObject.getComponent(SpriteComponent);

        spriteComponent.alpha = 0;
        transform.scale.set(0, 0);

        const scaleTween = this.getTween(transform.scale);
        const alphaTween = this.getTween(spriteComponent);

        alphaTween.to({ alpha: 1 }, 150).easing(Easing.Linear.None);
        scaleTween.to({ x: 1, y: 1 }, 600).easing(Easing.Elastic.Out);

        yield* AwaitIterators([
            this.startTween(scaleTween),
            this.startTween(alphaTween),
        ]);
    }
}
